import React from 'react';

import fetch from './../fetch';

import moment from 'moment';

import utils from './../../utils';

import {Modal, message} from 'antd';

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('eval/score/get', keywords)
    .then(response => {
        return response.payload;
    })
    .then(data => {
        const dataList = data.data
        const exParaMap = data.meta 
        const evalData = dataList.map(evals => {
            return {
                id: evals.id,
                pid: evals.pid,
                label: evals.evalName,
                children: evals.evalSubItem.map(sub => {
                    return {
                        id: sub.id,
                        pid: sub.itemId,
                        label: sub.subName,
                        choices: sub.choices
                    }
                })
            }
        });
        return {evalData:evalData ,exParaMap:exParaMap}
    })
    .then(response => {
        var scores = {};
        var parents = {};
        var values = {};

        var keys = [];
        var exParaMap = response.exParaMap;

        response.evalData.forEach(row => {
            parents["P" + row.id] = "P" + row.pid;
            values["P" + row.id] = row.label;

            row.children.forEach(child => {
                var childId = "C" + child.id;
                parents[childId] = "P" + child.pid;
                scores[childId] = child;
                keys.push(childId);
            });
        });

        return {
            scores,
            parents,
            values,
            keys,
            exParaMap
        };
    }).then(response => {
        var data = response.keys.map(key => {
            return getParents(key, response.parents, []);
        });

        var columnMaxValue = Math.max.apply(Math, data.map(d => d.length));

        var rowsCount = response.keys.length;

        return {
            exParaMap : response.exParaMap,
            scores: response.scores,
            values: response.values,
            columnMaxValue,
            rowsCount,
            data: data.map(function (d) {
                var size = columnMaxValue - d.length;
                var index = d.length - 2;
                var value = d[index];
                for (var i = 0; i < size; i++) {
                    d.splice(index + i, 0, value);
                }
                return d;
            })
        };
    }).then(response => {
        var columnMaxValue = response.columnMaxValue;
        var rowsCount = response.rowsCount;

        var grid = [];

        for (var i = 0; i < columnMaxValue; i++) {
            var lastValue = '';
            var lastIndex = 0;

            grid.push([]);

            for (var k = 0; k < rowsCount; k++) {
                var currentValue = response.data[k][i];

                if (lastValue !== currentValue) {
                    lastIndex = k;
                    lastValue = currentValue;

                    grid[i][k] = {
                        rowspan: 1,
                        value: currentValue
                    };
                } else {
                    grid[i][lastIndex].rowspan = grid[i][lastIndex].rowspan + 1;

                    grid[i][k] = {
                        rowspan: 0,
                        value: currentValue
                    };
                }
            }
        }

        var result = [];

        for (var i = 0; i < rowsCount; i++) {
            var row = [];

            for (var k = 0; k < columnMaxValue; k++) {
                row.push(grid[k][i]);
            }

            result.push(row);
        }

        var data = result.map(row => {
            return row.filter(d => d.rowspan !== 0);
        }).map(row => {
            const size = row.length;
            var columns = [];

            var lastValue = '';
            var lastIndex = 0;
            for (var i = 0; i < size; i++) {
                var currentValue = row[i].value;

                var clone = Object.assign({}, row[i], {
                    colspan: 1
                });

                if (currentValue !== lastValue) {
                    lastValue = currentValue;
                    lastIndex = i;
                } else {
                    columns[lastIndex].colspan = columns[lastIndex].colspan + 1;
                    clone.colspan = 0;
                }

                columns.push(clone);
            }
            return columns.filter(d => d.colspan);
        });

        return {
            exParaMap : response.exParaMap,
            scores: response.scores,
            values: response.values,
            data: data.map(row => {
                var size = row.length - 1;
                return {
                    columns: row.filter((d, i) => {
                        return i !== size;
                    }),
                    id: row[size].value
                }
            })
        };
    })
    .then(response => {
        var selects = {};
        response.data.forEach((row) => {
            var choice = response.scores[row.id].choices[0];
            selects[row.id] = {
                data: range(+choice.valueLow, +choice.valueHigh),
                value: +choice.valueNormal,
                index: 0
            };
        });

        var result = response.data.map(d => d.columns.length);

        var size = Math.max.apply(Math, result);

        var columns = range(1, size);
        var reverse = columns.reverse();
        
        return {
            exParaMap : response.exParaMap,
            selects: selects,
            scores: response.scores,
            values: response.values,
            data: response.data,
            columns: reverse,
            loading: false
        };
    });
}

const scoreCount = (domain) => {
    return fetch.post('eval/score/count', domain);
};

const getComments = (domain) => {
    return fetch.post('platform/comment/list', domain)
    .then(response => {
        return response.payload.data;
    });
}
/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const queryDetailById = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('evalteachereval/edit', keywords)
    .then(response => {
        return response.payload;
    }).then(reponseData => {
        const data = reponseData.data
        const meta = reponseData.meta
        const domain = {
            courseAdd: data.courseAdd,
            lessonAddress: data.lessonAddress,
            orgId: data.orgId,
            orgName: data.orgName,
            employeeId: data.employeeId,
            realName: data.realName,
            classesId: data.classesId,
            classesName: data.classesName,
            courseId: data.courseId,
            courseName: data.courseName,
            lessonNumBg: data.lessonNumBg || 1,
            lessonNumEnd: data.lessonNumEnd || 1,
            weekNum: data.weekNum || 1,
            weekName: data.weekName || "星期一",
            evalId: data.evalId,
            resultComment: data.resultComment,
            resultScore: data.resultScore,
            dudaoName: data.dudaoName,
            //考勤记录相关
            listenComment: data.listenComment,
            attendStudent: data.attendStudent,
            totalStudent: data.totalStudent,
            lateStudent: data.lateStudent,
            levelStudent: data.levelStudent,
            truantStudent: data.truantStudent
        }
        return {
            data: data.evalTargetList.map(evals => {
                return {
                    id: evals.id,
                    pid: evals.pid,
                    label: evals.evalName,
                    children: evals.evalSubItem.map(sub => {
                        return {
                            id: sub.id,
                            pid: sub.itemId,
                            label: sub.subName,
                            choices: sub.choices,
                            selectLabel: sub.selectLabel,
                            selectScore: sub.selectScore,
                            subitemType: sub.subitemType,
                            calcType: sub.calcType
                        }
                    })
                }
            }),
            domain: domain,
            evalExItem: meta.extParams.evalExItem
        };
    })
    .then(response => {
        var scores = {};
        var parents = {};
        var values = {};

        var keys = [];

        response.data.forEach(row => {
            parents["P" + row.id] = "P" + row.pid;
            values["P" + row.id] = row.label;

            row.children.forEach(child => {
                var childId = "C" + child.id;
                parents[childId] = "P" + child.pid;
                scores[childId] = child;
                keys.push(childId);
            });
        });

        return {
            scores,
            parents,
            values,
            keys,
            domain: response.domain,
            evalExItem: response.evalExItem
        };
    }).then(response => {
        var data = response.keys.map(key => {
            return getParents(key, response.parents, []);
        });

        var columnMaxValue = Math.max.apply(Math, data.map(d => d.length));

        var rowsCount = response.keys.length;

        return {
            scores: response.scores,
            values: response.values,
            columnMaxValue,
            rowsCount,
            data: data.map(function (d) {
                var size = columnMaxValue - d.length;
                var index = d.length - 2;
                var value = d[index];
                for (var i = 0; i < size; i++) {
                    d.splice(index + i, 0, value);
                }
                return d;
            }),
            domain: response.domain,
            evalExItem: response.evalExItem
        };
    }).then(response => {
        var columnMaxValue = response.columnMaxValue;
        var rowsCount = response.rowsCount;
        
        var grid = [];

        for (var i = 0; i < columnMaxValue; i++) {
            var lastValue = '';
            var lastIndex = 0;

            grid.push([]);

            for (var k = 0; k < rowsCount; k++) {
                var currentValue = response.data[k][i];

                if (lastValue !== currentValue) {
                    lastIndex = k;
                    lastValue = currentValue;

                    grid[i][k] = {
                        rowspan: 1,
                        value: currentValue
                    };
                } else {
                    grid[i][lastIndex].rowspan = grid[i][lastIndex].rowspan + 1;

                    grid[i][k] = {
                        rowspan: 0,
                        value: currentValue
                    };
                }
            }
        }

        var result = [];

        for (var i = 0; i < rowsCount; i++) {
            var row = [];

            for (var k = 0; k < columnMaxValue; k++) {
                row.push(grid[k][i]);
            }

            result.push(row);
        }

        var data = result.map(row => {
            return row.filter(d => d.rowspan !== 0);
        }).map(row => {
            const size = row.length;
            var columns = [];

            var lastValue = '';
            var lastIndex = 0;
            for (var i = 0; i < size; i++) {
                var currentValue = row[i].value;

                var clone = Object.assign({}, row[i], {
                    colspan: 1
                });

                if (currentValue !== lastValue) {
                    lastValue = currentValue;
                    lastIndex = i;
                } else {
                    columns[lastIndex].colspan = columns[lastIndex].colspan + 1;
                    clone.colspan = 0;
                }

                columns.push(clone);
            }
            return columns.filter(d => d.colspan);
        });

        return {
            scores: response.scores,
            values: response.values,
            data: data.map(row => {
                var size = row.length - 1;
                return {
                    columns: row.filter((d, i) => {
                        return i !== size;
                    }),
                    id: row[size].value
                }
            }),
            domain: response.domain,
            evalExItem: response.evalExItem
        };
    })
    .then(response => {
        var selects = {};

        response.data.forEach((row) => {
            var scoreItem = response.scores[row.id];

            var selectScore = scoreItem.selectScore;
            var showScore = scoreItem.showScore;
            var subitemType = scoreItem.subitemType;
            var choices = response.scores[row.id].choices;
            if (subitemType === 'options' || subitemType === 'select') {
                var index = findSelectScore(choices, +selectScore);
                var choice = choices[index];
                selects[row.id] = {
                    data: range(+choice.valueLow, +choice.valueHigh),
                    value: +selectScore,
                    index: index,
                    showScore: showScore,
                    subitemType: subitemType
                };
            } else if (subitemType === 'multiple') {
                const selectLabels = JSON.parse(scoreItem.selectLabel)
                const index = [];
                for (let i = 0; i <= choices.length - 1; i ++) {
                    for (let j = 0; j <= selectLabels.length - 1; j ++) {
                        if (choices[i].label === selectLabels[j]) {
                            index.push(i);
                        }
                    }
                }
                selects[row.id] = {
                    data: [],
                    index: index,
                    showScore: 2, 
                    subitemType: subitemType
                }
            } else if (subitemType === 'text') {
                selects[row.id] = {
                    data: (scoreItem.selectLabel === null || scoreItem.selectLabel === undefined) ? '' : scoreItem.selectLabel,
                    showScore: 2, 
                    subitemType: subitemType
                }
            }
        });

        var result = response.data.map(d => d.columns.length);

        var size = Math.max.apply(Math, result);

        var columns = range(1, size);
        var reverse = columns.reverse();

        return {
            selects: selects,
            scores: response.scores,
            values: response.values,
            data: response.data,
            columns: reverse,
            loading: false,
            domain: response.domain,
            evalExItem: response.evalExItem
        };
    });
}

const findSelectScore = (choices, selectScore) => {
    var index = -1;
    for(var i = 0 ; i < choices.length; i++ ){
        const choice = choices[i];
        const min = +choice.valueLow;
        const max = +choice.valueHigh
        if(selectScore >= min && selectScore <=max) {
            index = i;
            break;
        }
    }

    return index;
}

const getParents = (id, parents, row) => {
    if (parents.hasOwnProperty(id) === true) {
        return row.unshift(id), getParents(parents[id], parents, row);
    } else {
        return row.slice(1);
    }
}

const range = (start, stop) => {
    var result = [];
    for (stop; stop >= start; stop--) {
        result.push(stop);
    }

    return result;
}

const insert = (domain) => {
    return fetch.post('eval/score/insert', domain);
}

const check = (domain) => {
    return fetch.post('eval/score/check/eval', domain)
    .then(response => {
        return response;
    });
}

const update = (id, domain) => {
    return fetch.post('eval/result/update/'+ id, domain);
}

export default {
    querySearch,
    queryDetailById,
    insert,
    update,
    check,
    scoreCount
}